<template>
  <va-dropdown
    v-for="(route, idx) in items"
    :key="idx"
    position="right"
    fixed
    :offset="[0, 8]"
    :preventOverflow="false"
    v-model="dropdownsValue[idx]"
  >
    <template #anchor>
      <va-sidebar-item @click="showDasboard(route)" :active="isItemChildsActive(route)"
                       :to="route.children ? undefined : { name: route.name }">
        <va-sidebar-item-content>
          <va-sidebar-item-title>

            <!-- 改变侧栏图标的大小  -->
            <va-icon v-if="route.name!='vote'" :title="$t(route.displayName)" :name="route.meta.icon"/>
            <img :title="$t(route.displayName)" v-if="route.name=='vote'" src="@/static/images/heart.gif" height='30'
                 alt="">
          </va-sidebar-item-title>
          <va-icon
            v-if="route.children"
            class="more_icon"
            :name="dropdownsValue[idx] ? 'chevron_left' : 'chevron_right'"/>
        </va-sidebar-item-content>
      </va-sidebar-item>
    </template>
    <div class="sidebar-item__children">
      <template  v-for="(child, index) in route.children" :key="index">
        <va-sidebar-item
          :active="isRouteActive(child)"
          :to="child.externalUrl ? undefined : { name: child.name }"
          @click="openExternalRoute(child)"
        >
          <va-sidebar-item-content>
            <va-sidebar-item-title>
              {{ $t(child.displayName) }}
            </va-sidebar-item-title>
          </va-sidebar-item-content>
        </va-sidebar-item>
      </template>
    </div>


  </va-dropdown>
</template>

<script>
import {useGlobalConfig} from 'vuestic-ui';

export default {
  name: "AppMenuMinimized",
  props: {
    items: {type: Array, default: () => []}
  },
  data() {
    return {
      dropdownsValue: [],
      url: '',
      url2:'',
      heart: 'public/img/vuestic-admin-logo.png'
    }
  },
  computed: {
    theme() {
      return useGlobalConfig().getGlobalConfig().colors
    },
  },
  methods: {
    openExternalRoute(route) {
      if (route.externalUrl) {
        window.open(route.externalUrl, '_blank', 'noopener,noreferrer');
      }
    },
    showDasboard(route) {
      if (route.name === 'statistics') {
        window.open(this.url, '_blank');
      }else if(route.name === 'statisticsNew'){
        window.open(this.url2, '_blank');
      }
    },
    isGroup(item) {
      return !!item.children;
    },
    isRouteActive(item) {
      return item.name === this.$route.name;
    },
    isItemChildsActive(item) {
      if (!item.children) {
        return false;
      }

      const isCurrentItemActive = this.isRouteActive(item);
      const isChildActive = !!item.children.find(child =>
        child.children ? this.isItemChildsActive(child) : this.isRouteActive(child)
      );

      return isCurrentItemActive || isChildActive;
    },
    loadUrl() {
      this.$api.dashboardAPI.getTableauUrl()
        .then(res => {
          if (res.data.Success === false) {
            // VXETable.modal.message({content: res.data.Message, status: 'error'});
            return;
          }
          this.url = res.data.Data.split(',')[0];
          this.url2 = res.data.Data.split(',')[1];

        })
        .catch(error => {
          console.log(error);
        })
    }
  },
  mounted() {
    this.loadUrl();
  }
};
</script>

<style lang="scss" scoped>
.sidebar-item {
  position: relative;

  &__children {
    max-height: 60vh;
    overflow-y: auto;
    overflow-x: visible;
    min-width: 8rem;
    width: 130px;
    color: var(--va-gray);
    background: var(--va-white);
    box-shadow: var(--va-box-shadow);
  }
}

.va-sidebar-item {
  &__icon {
    margin: 0;
  }

  &-content {
    position: relative;

    .more_icon {
      text-align: center;
      position: absolute;
      bottom: 0.5rem;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
    }
  }
}

.mysize {
  font-size: 29px
}

.va-sidebar-item-content {
  padding: 0.75rem 1rem;
  padding-top: 0.75rem;
  padding-right: 1rem;
  padding-bottom: 0.75rem;
  padding-left: 1rem;
}

</style>
